<div class="dropdown">
  <div class="dropdown-header flex items-center justify-between">
    <div>
      <div class="dropdown-heading">Notificaciones</div>
      <div class="dropdown-subheading">
        Tienes {{ notifications.length }} notificaciones.
      </div>
    </div>
  </div>

  <div class="dropdown-content">
    <!-- Spinner de carga usando CSS -->
    <div *ngIf="isLoading" class="loading-indicator">
      <div class="loading-spinner"></div>
      <span>Cargando notificaciones...</span> <!-- Se añadió el <span> para aplicar estilo al texto -->
    </div>

    <!-- Mostrar notificaciones cuando se hayan cargado -->
    <a *ngFor="let notification of notifications; trackBy: trackById"
       [class.read]="notification.leida"
       class="notification flex items-center"
       (click)="markAsRead(notification.id)"
       matRipple>
      <mat-icon [ngClass]="notification.colorClass"
                [svgIcon]="notification.icon"
                class="notification-icon flex-none"></mat-icon>
      <div class="flex-auto">
        <div class="notification-label">{{ notification.descripcion }}</div>
        <div class="notification-description">
          {{ notification.fecha_creacion | fechaEspanol:'relativa' }}
        </div>
      </div>
    </a>
  </div>

  <div class="dropdown-footer flex items-center justify-center">
    <button mat-button (click)="markAllAsRead()" [disabled]="notifications.length === 0">Marcar todas como leídas</button>
  </div>
</div>
